import React, { useState } from 'react'
import './App.css';
import Restaurant from './component/Restaurant';
import Menu from './component/Menu';
import FilterMenu from './component/FilterMenu';
import About from './component/About';
import Contact from './component/Contact';
import Navbar from './component/Navbar';
import Footer from './component/Footer';
import Home from './component/Home';
// import TodoApp from './component/TodoApp';
// import Greetings from './component/Greetings';
// import * as multipalCom from "./component/ImportExport";

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

const menuNav = [...new Set(Menu.map(n => {
  return n.category
})), 'all'];

function App() {
  const [menuData, setmenuData] = useState(Menu)

  const MenuFilter = (cat) => {
    if (cat === 'all') {
      setmenuData(Menu)
      return
    }
    const updatedData = Menu.filter(f => {
      return f.category === cat
    })
    setmenuData(updatedData)
  };

  return (
    <Router>
      <div className="container-fluid p-0">
        <Navbar />
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <div className="container">
          <Switch>
            <Route path="/restaurant">
              <Home />
            </Route>
            <Route path="/Category">
              <FilterMenu menuNav={menuNav} MenuFilter={MenuFilter} />
              <Restaurant menuData={menuData} />
            </Route>
            <Route path="/About">
              <About />
            </Route>
            <Route path="/Contact">
              <Contact />
            </Route>
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
